/**
 * It builds the url based on params sent
 * @param {Object} params : It is the object with url params
 * @returns {String} url : It is the built string url with params
 * @returns {String} string : It is the main url path
 */
const buildUrlandParams = (params = {}, path) => {
  const paramsObject = new URLSearchParams(params);
  const url = new URL(`${path}?${paramsObject.toString()}`,BASE);
  return url.href;
};

/**
 * It handles click on specific filter
 * @param {Object} event : It is the event fired from the HTMLElement clicked
 */
const handleFiltersClick = async (event, sortBarFilters, _params, callback) => {
  const {
    srcElement: {
      dataset: { type, order },
    },
  } = event;

  if (!type || !order) return;

  if (type === 'ASC') {
    event.srcElement.dataset.type = 'DESC';
  } else {
    event.srcElement.dataset.type = 'ASC';
  }

  const params =
    _params === 'reviews'
      ? {
          page: 1,
          order: type,
          orderIn: order,
          take: $one("select[name='numViewReviews']").value,
        }
      : {
          page: 1,
          [`order${capitalize(order)}`]: type,
        };

  callback(params);

  sortBarFilters.forEach((filter) => {
    if (filter === event.srcElement) {
      filter.dataset.current = 'true';
      event.srcElement.classList.add('active');
    } else {
      filter.dataset.current = 'false';
      filter.classList.remove('active');
    }
  });
};

/**
 * It capitalizes a string
 * @param {String} string : It is the string to capitalize
 * @returns {String} capitalized : It is the string capitalized
 */
const capitalize = (string) => {
  if (!string) return;
  const capitalizedString = string.charAt(0).toUpperCase() + string.slice(1);
  return capitalizedString;
};

/**
 * It cleans the pagination elements
 */
const cleanContainerElements = (query, subquery) => {
  const totalElements = $one(`${query}`).querySelectorAll(`${subquery}`);

  totalElements.forEach((element) => {
    element.remove();
  });
};

/**
 * It fetches product info from graphql
 * @param {String} productId : It is the product id
 * @returns {Object} object : It is the response fetched
 */
const getProductInfo = async (productId) => {
  const URL = `/api/2024-04/graphql.json`;

  const data = `{
    product(id: "gid://shopify/Product/${productId}") {
      title
      handle
      images(first: 1) {
        edges {
          node {
            url
          }
        }
      }
      variants(first: 1) {
        edges {
          node {
            priceV2 {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
  `;

  const rs = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': StorefrontAccessToken,
    },
    body: data,
  });

  const result = await rs.json();
  return result;
};

/**
 * It gets info of a product list
 * @param {Array} productsArray : It is the products array
 * @returns {Object} result : It is the info result for products
 */
const getArrayProductsInfo = async (productsArray = []) => {
  const URL = `/api/2024-04/graphql.json`;
  let data = "{";
  data += productsArray.map((product, index) => {
    const { product_productId: id } = product;
     return `product_${id}: product(id: "gid://shopify/Product/${id}") {
      title
      id
      handle
      images(first: 1) {
        edges {
          node {
            url
          }
        }
      }
      number_of_reviews: metafield(key: "number_of_reviews", namespace: "custom") {
        value
      },
      average_rating: metafield(key: "average_rating", namespace: "custom") {
        value
      }
    }`;
  }).join(",\n");
  data += "}";

  const rs = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': StorefrontAccessToken,
    },
    body: data,
  });

  const result = await rs.json();

  return result;
};

// format date in fr
const formatDate = (date) => {
  const event = new Date(date);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return event.toLocaleDateString('fr-FR', options);
};

// only number in input
const forceNumeric = (e) => {
  e.target.value = e.target.value
    .replace(/[^\d.]/g, '')
    .replace(/\.(?=.*\.)/g, '');
};
